import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { useState } from "react";
import { PositionSkillRef } from "../../../models/recruiting/positions/position-skill/position-skill-ref";
import { useTranslation } from "react-i18next";

export const RequiredSkillsQuickfilter = ({ requiredSkills, setSkillsIds }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.required_skills"; // tRP - translation root path

  const [checkedRequiredSkills, setCheckedRequiredSkills] = useState<PositionSkillRef[]>(requiredSkills ?? []);

  const handleChangeSkills = (event: SelectChangeEvent<typeof checkedRequiredSkills>) => {
    const value = event.target.value as PositionSkillRef[];
    const checkedIds = value.map((el) => el?.skill?.id as string);
    setCheckedRequiredSkills(value as PositionSkillRef[]);
    setSkillsIds(checkedIds);
  };

  return (
    <div>
      <FormControl sx={{ m: 1 }}>
        {!!requiredSkills?.length ? (
          !!checkedRequiredSkills?.length ? (
            <InputLabel id={"multiple-checkbox-label"}>{t(`${tRP}.skills_filter_label`)}</InputLabel>
          ) : (
            <InputLabel
              id={"multiple-checkbox-label"}
              shrink={true}
            >
              {t(`${tRP}.skills_filter_label`)}
            </InputLabel>
          )
        ) : (
          <InputLabel
            id={"multiple-checkbox-label"}
            shrink={false}
          >
            {t(`${tRP}.no_skills_options`)}
          </InputLabel>
        )}
        <Select
          labelId="multiple-checkbox-label"
          id="multiple-checkbox"
          multiple
          value={checkedRequiredSkills}
          onChange={handleChangeSkills}
          input={!!requiredSkills?.length ? <OutlinedInput label={t(`${tRP}.skills_filter_label`)} /> : undefined}
          renderValue={(selected) => {
            if (!selected.length && !!requiredSkills?.length) {
              return t(`${tRP}.default_label`);
            }

            return selected.map((el) => el?.skill?.name).join(", ");
          }}
          MenuProps={{
            PaperProps: {
              style: {
                minWidth: "200px",
                display: !!requiredSkills?.length ? "inherit" : "none",
              },
            },
          }}
          sx={{ width: 200 }}
          displayEmpty={true}
          notched={true}
        >
          {requiredSkills?.map((skill) => (
            <MenuItem
              key={skill?.id}
              value={skill as any}
            >
              <Checkbox checked={checkedRequiredSkills.indexOf(skill) > -1} />
              <ListItemText primary={skill?.skill?.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

type Props = {
  requiredSkills: PositionSkillRef[] | null;
  setSkillsIds: React.Dispatch<React.SetStateAction<string[]>>;
};
